import React from 'react';

/**
 * 공고 본문용 초경량 마크업 렌더러.
 *  - `**굵게**` → <strong>
 *  - 줄 앞 `- ` / `* ` / `• ` → 글머리 기호 목록
 *  - 그 외 줄바꿈은 그대로 유지
 * 색상·링크 등은 지원하지 않는다 (요구 범위: 볼드 + 글머리 기호).
 */
const BULLET_RE = /^\s*(?:[-*•]|\d+[.)])\s+/;

const renderInline = (text, keyPrefix) => {
  const parts = text.split(/(\*\*[^*]+\*\*)/g).filter(Boolean);
  return parts.map((part, i) => {
    if (part.startsWith('**') && part.endsWith('**') && part.length > 4) {
      return (
        <strong key={`${keyPrefix}-${i}`} className='font-bold'>
          {part.slice(2, -2)}
        </strong>
      );
    }
    return <React.Fragment key={`${keyPrefix}-${i}`}>{part}</React.Fragment>;
  });
};

export const hasRichMarkup = (text = '') =>
  /\*\*[^*]+\*\*/.test(text) || text.split('\n').some((l) => BULLET_RE.test(l));

const RichText = ({ text, className = '' }) => {
  const lines = String(text ?? '')
    .replace(/\r\n/g, '\n')
    .split('\n');
  const blocks = [];
  let list = null;

  lines.forEach((line, idx) => {
    if (BULLET_RE.test(line)) {
      if (!list) {
        list = [];
        blocks.push({ type: 'ul', items: list, key: `ul-${idx}` });
      }
      list.push({ text: line.replace(BULLET_RE, ''), key: `li-${idx}` });
    } else {
      list = null;
      blocks.push({ type: 'p', text: line, key: `p-${idx}` });
    }
  });

  return (
    <div className={`typo-b14 ${className}`}>
      {blocks.map((block) =>
        block.type === 'ul' ? (
          <ul key={block.key} className='list-disc pl-5 my-1 space-y-0.5'>
            {block.items.map((item) => (
              <li key={item.key}>{renderInline(item.text, item.key)}</li>
            ))}
          </ul>
        ) : (
          // 빈 줄은 문단 간격으로
          <p key={block.key} className={block.text.trim() ? '' : 'h-3'}>
            {renderInline(block.text, block.key)}
          </p>
        ),
      )}
    </div>
  );
};

export default RichText;
